import { Col, Row, Modal, notification, Button } from "antd";
import BatteryPerformance from "./Analytics/Battery";
import BrakeAnalytics from "./Analytics/Brake";
import RideAnalytics from "./Analytics/Ride";
import SpeedAnalytics from "./Analytics/Speed";
import Overview from "./Overview";
import SpeedMap from "./SpeedMap";
import TripHighlight from "./TripHighlight";
import VehicleDetails from "../../VehicleDetails";
import { useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import GrafanaCompare from "./grafanaCompare";
import TripStopAnalytics from "./Analytics/TripStops";
import AccelerationAnalytics from "./Analytics/Acceleration";
// import EnergyAnalytics from "./Analytics/ Energy";
import DecelerationAnalytics from "./Analytics/Deceleration";
import { getGrafanaBaseURL, 
  getGrafanaInterval,
  getGrafanaBatteryStackInterval,
  getGrafanaBatteryCellInterval } from "../../../Common/Utils";
import { TEST_RIDE_SUMMARY } from "../../../Common/Grafana/Constants";
import TurnsAnalytics from "./Analytics/Turns";

const RideStatistics = ({ onChangeVehicle, vehicle, rearTyreDiameter }) => {
  const vehicleDetails = useSelector((state) => state.eol.vehicleDetails);
  const tripSummary = useSelector((state) => state.testRide.tripSummary);
  const [api, contextHolder] = notification.useNotification({ maxCount: 1 });
  const [compareValue, setCompareValue] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const baseFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    
    return {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      vehicle_id: vehicleDetails?.vehId,
      testid: tripSummary?.rideForm?.testId,
      interval: getGrafanaInterval(
        tripSummary?.rideForm?.startTime,
        tripSummary?.rideForm?.stopTime
      ),
      from: tripSummary?.rideForm?.startTime,
      to: tripSummary?.rideForm?.stopTime,
      rear_wheel_diameter: rearTyreDiameter,
    }
  }, [vehicleDetails?.vehId, tripSummary?.rideForm?.testId, tripSummary?.rideForm?.startTime, tripSummary?.rideForm?.stopTime, rearTyreDiameter]);

  const batteryStackFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    
    return {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      vehicle_id: vehicleDetails?.vehId,
      testid: tripSummary?.rideForm?.testId,
      interval: getGrafanaBatteryStackInterval(
        tripSummary?.rideForm?.startTime,
        tripSummary?.rideForm?.stopTime
      ),
      from: tripSummary?.rideForm?.startTime,
      to: tripSummary?.rideForm?.stopTime,
      rear_wheel_diameter: rearTyreDiameter,
    }
  }, [vehicleDetails?.vehId, tripSummary?.rideForm?.testId, tripSummary?.rideForm?.startTime, tripSummary?.rideForm?.stopTime, rearTyreDiameter]);

  const batteryCellFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    
    return {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      vehicle_id: vehicleDetails?.vehId,
      testid: tripSummary?.rideForm?.testId,
      interval: getGrafanaBatteryCellInterval(
        tripSummary?.rideForm?.startTime,
        tripSummary?.rideForm?.stopTime
      ),
      from: tripSummary?.rideForm?.startTime,
      to: tripSummary?.rideForm?.stopTime,
      rear_wheel_diameter: rearTyreDiameter,
    }
  }, [vehicleDetails?.vehId, tripSummary?.rideForm?.testId, tripSummary?.rideForm?.startTime, tripSummary?.rideForm?.stopTime, rearTyreDiameter]);

  const showModal = () => {
    setIsModalOpen(true);
    api.destroy();
  };

  useEffect(() => {
    if (compareValue?.length > 0) {
      api.open({
        message: "",
        closeIcon: false,
        key: "compare",
        description: [
          <Button type="primary" onClick={showModal} data-testid="compare-btn" key={"compare"+compareValue?.length} style={{ zIndex: 1 }}>
            Compare ({compareValue?.length})
          </Button>,
        ],
        duration: 0,
        maxCount: 1,
        className: "compare-notification",
        placement: "bottomRight",
      });
    } else {
      api.destroy();
    }

    // eslint-disable-next-line
  }, [api, compareValue]);

  const updateCompareValue = (name, value) => {
    if (compareValue?.length > 2 && value) {
      toast.error(`Maximum 3 graphs can be compare`);
    } else {
      setCompareValue((prev) =>
        value ? [...prev, name] : prev.filter((item) => item !== name)
      );
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setCompareValue([]);
  };

  return (
    <div className="test-ride-statistic-page" data-testid="test-ride-statistic">
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={24} md={24} lg={6} xl={5}>
          <VehicleDetails onChangeImei={onChangeVehicle} imei={vehicle} />
        </Col>
        <Col xs={24} sm={24} md={24} lg={18} xl={19}>
          <Overview />
        </Col>
      </Row>
      <Row className="mt1">
        <Col span={24}>
          <TripHighlight />
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <SpeedMap
            baseUrl={getGrafanaBaseURL(
              TEST_RIDE_SUMMARY.DASHBOARD_ID,
              TEST_RIDE_SUMMARY.DASHBOARD_NAME
            )}
            baseFilterObject={baseFilterObject}
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} className="mt075">
        <Col span={24}>
          <SpeedAnalytics
            compareValue={compareValue}
            baseUrl={getGrafanaBaseURL(
              TEST_RIDE_SUMMARY.DASHBOARD_ID,
              TEST_RIDE_SUMMARY.DASHBOARD_NAME
            )}
            baseFilterObject={baseFilterObject}
            updateCompareValue={updateCompareValue}
          />
        </Col>
        <Col span={24}>
          <BatteryPerformance
            compareValue={compareValue}
            baseUrl={getGrafanaBaseURL(
              TEST_RIDE_SUMMARY.DASHBOARD_ID,
              TEST_RIDE_SUMMARY.DASHBOARD_NAME
            )}
            baseFilterObject={baseFilterObject}
            batteryStackFilter={batteryStackFilterObject}
            batteryCellFilter={batteryCellFilterObject}
            updateCompareValue={updateCompareValue}
          />
        </Col>
        <Col span={24}>
          <BrakeAnalytics
            compareValue={compareValue}
            baseUrl={getGrafanaBaseURL(
              TEST_RIDE_SUMMARY.DASHBOARD_ID,
              TEST_RIDE_SUMMARY.DASHBOARD_NAME
            )}
            baseFilterObject={baseFilterObject}
            updateCompareValue={updateCompareValue}
          />
        </Col>
        <Col span={24}>
          <TurnsAnalytics
            compareValue={compareValue}
            baseUrl={getGrafanaBaseURL(
              TEST_RIDE_SUMMARY.DASHBOARD_ID,
              TEST_RIDE_SUMMARY.DASHBOARD_NAME
            )}
            baseFilterObject={baseFilterObject}
            updateCompareValue={updateCompareValue}
          />
        </Col>
        <Col span={24}>
          <TripStopAnalytics
            compareValue={compareValue}
            baseUrl={getGrafanaBaseURL(
              TEST_RIDE_SUMMARY.DASHBOARD_ID,
              TEST_RIDE_SUMMARY.DASHBOARD_NAME
            )}
            baseFilterObject={baseFilterObject}
            updateCompareValue={updateCompareValue}
          />
        </Col>
        <Col xs={24} sm={24} md={12}>
          <AccelerationAnalytics
            compareValue={compareValue}
            baseUrl={getGrafanaBaseURL(
              TEST_RIDE_SUMMARY.DASHBOARD_ID,
              TEST_RIDE_SUMMARY.DASHBOARD_NAME
            )}
            baseFilterObject={baseFilterObject}
            updateCompareValue={updateCompareValue}
          />
        </Col>
        <Col xs={24} sm={24} md={12}>
          <DecelerationAnalytics
            compareValue={compareValue}
            baseUrl={getGrafanaBaseURL(
              TEST_RIDE_SUMMARY.DASHBOARD_ID,
              TEST_RIDE_SUMMARY.DASHBOARD_NAME
            )}
            baseFilterObject={baseFilterObject}
            updateCompareValue={updateCompareValue}
          />
        </Col>
        <Col span={24}>
          <RideAnalytics />
        </Col>
      </Row>
      {contextHolder}
      <Modal
        title="Compare"
        centered
        open={isModalOpen}
        onCancel={handleCancel}
        className="compare-modal"
        footer={null}
        width="100%"
        height="100%"
        style={{ top: 0 }}
      >
        <GrafanaCompare
          vehicleDetails={vehicleDetails}
          baseUrl={getGrafanaBaseURL(
            TEST_RIDE_SUMMARY.DASHBOARD_ID,
            TEST_RIDE_SUMMARY.DASHBOARD_NAME
          )}
          baseFilterObject={baseFilterObject}
          compareCharts={compareValue}
        />
      </Modal>
    </div>
  );
};

export default RideStatistics;